var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon31(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.624817 0.250977V10.751H9.65482C9.46232 10.1647 9.37482 9.57848 9.37482 9.00098H4.12482C4.12482 8.03848 3.34607 7.25098 2.37482 7.25098V3.75098C3.34607 3.75098 4.12482 2.97223 4.12482 2.00098H12.8748C12.8748 2.97223 13.6623 3.75098 14.6248 3.75098V3.80348C15.2111 3.80348 15.7973 3.90848 16.3748 4.10098V0.250977H0.624817ZM8.49982 2.87598C7.01232 2.90223 5.87482 4.01348 5.87482 5.50098C5.87482 6.98848 7.01232 8.07348 8.49982 8.12598C8.83232 8.12598 9.17357 8.05598 9.49732 7.92473C9.73357 6.96223 10.1273 6.05223 11.0986 5.15973C10.9936 3.99598 9.89107 2.84973 8.49982 2.87598ZM16.9261 5.73723L13.5398 9.14973L12.3586 7.95098L11.1248 9.19348L13.5311 11.626L18.1511 6.97098L16.9261 5.73723Z",
    fill: "#FF5E43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon31);
export default __webpack_public_path__ + "static/media/icon31.ace54ddc20427a003dd3d3e990c3f2c4.svg";
export { ForwardRef as ReactComponent };